import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import BookingSection from "@/components/BookingSection";
import AboutWill from "@/components/AboutWill";
import Community from "@/components/Community";
import Showcase from "@/components/Showcase";
import Footer from "@/components/Footer";
import AdminPage from "@/pages/Admin";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-white p-8 text-center">
          <p className="font-serif text-2xl text-ink">
            Something went wrong — please refresh the page.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route
            path="/admin"
            element={<AdminPage />}
          />
          <Route
            path="*"
            element={
              <div className="grain-overlay min-h-screen bg-white font-sans text-ink">
                <Header />
                <main>
                  <Hero />
                  <Marquee />
                  <BookingSection />
                  <AboutWill />
                  <Community />
                  <Showcase />
                </main>
                <Footer />
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}